import { __assign, __rest } from "tslib";
import React from 'react';
import VeltTranscriptionCloseButtonWireframe from '../VeltTranscriptionCloseButtonWireframe/VeltTranscriptionCloseButtonWireframe';
import VeltTranscriptionContentWireframe from '../VeltTranscriptionContentWireframe/VeltTranscriptionContentWireframe';
import VeltTranscriptionCopyLinkWireframe from '../VeltTranscriptionCopyLinkWireframe/VeltTranscriptionCopyLinkWireframe';
import VeltTranscriptionSummaryWireframe from '../VeltTranscriptionSummaryWireframe/VeltTranscriptionSummaryWireframe';
import { transformWireframeProps } from '../../../utils/propUtils';
var VeltTranscriptionPanelWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-transcription-panel-wireframe", __assign({}, transformedProps), children));
};
VeltTranscriptionPanelWireframe.CloseButton = VeltTranscriptionCloseButtonWireframe;
VeltTranscriptionPanelWireframe.CopyLink = VeltTranscriptionCopyLinkWireframe;
VeltTranscriptionPanelWireframe.Summary = VeltTranscriptionSummaryWireframe;
VeltTranscriptionPanelWireframe.Content = VeltTranscriptionContentWireframe;
export default VeltTranscriptionPanelWireframe;
